// r140 — serviço da Agenda
import { api } from './auth.service';

const agendaService = {

  // Lista minhas alocações no período (passa usuario_id como query — o backend valida)
  listarMinhasAlocacoes: async (usuarioId, inicio, fim) => {
    const r = await api.get('/agenda/minhas-alocacoes', {
      params: { inicio, fim, usuario_id: usuarioId },
    });
    return r.data;
  },

  // Planeja uma tarefa no calendário (cria alocação TAREFA_PLANEJADA, sem apontamento)
  planejarTarefa: async ({ tarefa_id, data_inicio, data_fim, usuario_id, force }) => {
    const r = await api.post('/agenda/planejar', {
      tarefa_id, data_inicio, data_fim, usuario_id, force: !!force,
    });
    return r.data;
  },

  // Mover/redimensionar uma alocação planejada
  alterar: async (alocacaoId, { data_inicio, data_fim, usuario_id, force }) => {
    const r = await api.put(`/agenda/${alocacaoId}`, {
      data_inicio, data_fim, usuario_id, force: !!force,
    });
    return r.data;
  },

  // Cancelar alocação planejada
  cancelar: async (alocacaoId, usuarioId) => {
    const r = await api.delete(`/agenda/${alocacaoId}`, {
      data: { usuario_id: usuarioId },
    });
    return r.data;
  },
};

export default agendaService;
